import { general } from './general';

export const datecontrol = (data = {}) => general('datecontrol', (data || {}));
